import { render, staticRenderFns } from "./OrdersUpdateDate.vue?vue&type=template&id=804d87f6"
import script from "./OrdersUpdateDate.vue?vue&type=script&lang=js"
export * from "./OrdersUpdateDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports